import request from '@/libs/request'
import { toast } from '../libs/utils'

// 获取历史检查列表
export async function getHistoryCheck (params) {
  let data = await request.post('/order/orderCheckOrderInfo/getCheckHistoryList', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取历史检查列表异常！' })
  }
}

// 获取检查统计数据
export async function getHistoryCheckStatistics (params) {
  let data = await request.post('/order/orderCheckOrderInfo/findHistoryStatistics', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取历史检查统计数据异常！' })
  }
}


// 生成Excel
export async function getStaticHistory (params) {
  let data = await request.post('/order/orderCheckOrderInfo/downloadExl', params, false, { responseType: 'blob' })
  return data || null
}
// 获取额外费用
export async function getOtherPrice (params) {
  let data = await request.post('/order/orderCheckOrderInfo/queryMaterialByOrderCheckId', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取额外费用异常' })
  }
}
// 获取影像中心下的耗材列表
export async function getConsumListByCenter (params) {
  let data = await request.post('/order/orderCheckOrderInfo/queryMaterialByMedicalImageCenterId', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取影像中心下的耗材列表异常' })
  }
}
// 新增额外费用
export async function addOtherPrice (params) {
  let data = await request.postJson('/order/orderCheckOrderInfo/addOrderCheckMaterial', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '新增额外费用异常' })
  }
}
// 修改患者来源
export async function changePatientFrom (params) {
  let data = await request.post('/order/orderCheckOrderInfo/updateOrderSource', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '修改患者来源异常' })
  }
}
// 修改额外费用
export async function editOtherPrice (params) {
  let data = await request.postJson('/order/orderCheckOrderInfo/updateOrderCheckMaterial', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '修改额外费用异常' })
  }
}
// 删除额外费用耗材
export async function removePriceConsum (params) {
  let data = await request.post('/order/orderCheckOrderInfo/deleteOrderCheckMaterialById', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '删除额外费用耗材异常' })
  }
}
// 删除主订单额外费用耗材
export async function removePriceConsumOrder (params) {
  let data = await request.post('/order/orderCheckOrderInfo/deleteOrderCheckMaterialByOrderCheckId', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '删除额外费用异常' })
  }
}
// 匹配历史检查
export async function matchHistoryList (params) {
  let data = await request.post('/order/orderCheckOrderInfo/historyOrdersMatching', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '匹配历史检查异常' })
  }
}
// 查询是否为问题订单
export async function isQuestionOrder (params) {
  let data = await request.post('/order/orderCommission/queryOperation', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '查询订单信息异常' })
  }
}
// 退费
export async function checkOrderRefundFee (params) {
  let data = await request.post('/order/orderCheckOrderInfo/refundCheckOrder', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '修改订单实收金额异常' })
    return false
  }
}
// 修改患者手机号
export async function updatePatientMobile (params) {
  let data = await request.post('/order/orderCheckOrderInfo/updatePatientMobile', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '修改患者手机号异常' })
    return false
  }
}
